import MODEL_QUERY from 'graphql/model.query'
import WORDPRESS_MODEL_QUERY from 'graphql/wordpressModel.query'
import ModelPage from '../../../components/ModelPage'
import uppercaseFirst from '../../../helpers/uppercaseFirst'
import Layout from '../../../components/Layout'
import StateInitializer from '../../../components/StateInitializer'
import getGlobalSettings from '../../../helpers/getGlobalSettings'
import getSites from '../../../helpers/getSites'
import PropTypes from 'prop-types'
import { createApolloClient } from '../../../lib/createApolloClient'

function ModelQuery(props) {
  const {
    globalSettings,
    sites,
    siteSlug,
    title,
    site,
    boardType,
    boardSlug,
    modelSlug,
  } = props

  return (
    <StateInitializer
      globalSettings={globalSettings}
      sites={sites}
      siteSlug={siteSlug}
    >
      <Layout>
        <ModelPage
          {...props}
          url={`/${site}/${boardType}/${boardSlug}/${modelSlug}`}
          title={`${title}${boardType ? ` | ${uppercaseFirst(boardType)}` : ''}`}
        />
      </Layout>
    </StateInitializer>
  )
}

ModelQuery.propTypes = {
  globalSettings: PropTypes.object.isRequired,
  sites: PropTypes.array.isRequired,
  siteSlug: PropTypes.string.isRequired,
  title: PropTypes.string,
  site: PropTypes.string.isRequired,
  boardType: PropTypes.string.isRequired,
  boardSlug: PropTypes.string.isRequired,
  modelSlug: PropTypes.string.isRequired,
}

export default ModelQuery

export async function getStaticProps({ params }) {
  const { site, modelSlug, boardType } = params

  const apolloClient = createApolloClient()

  const [
    globalSettings,
    sites,
    { data, error },
    { data: agencyPinData, error: agencyPinError },
  ] = await Promise.all([
    getGlobalSettings(site),
    getSites(),
    apolloClient
      .query({
        query: WORDPRESS_MODEL_QUERY,
        context: { site },
        variables: { site, modelUri: modelSlug, boardType },
      })
      .catch((e) => {
        return { data: null, error: e }
      }),
    apolloClient
      .query({
        query: MODEL_QUERY,
        context: { site: 'solarnet' },
        variables: { modelUri: modelSlug, boardType, site },
      })
      .catch((e) => {
        return { data: null, error: e }
      }),
  ])

  if (error || agencyPinError) {
    console.error(`Error loading Model props - ${error}`)
    return { props: {}, notFound: true }
  }

  // The cover image should be the very first image in the gallery and not the model image!!
  const image =
    agencyPinData.model?.galleries[0]?.assets[0] ?? agencyPinData.model?.image

  const props = {
    ...params,
    ...data.modelBy,
    ...data.modelBy?.acfModel,
    ...agencyPinData.model,
    image,
    globalSettings,
    sites,
    siteSlug: site,
  }

  return {
    props,
    revalidate: 60 * 60,
  }
}

export async function getStaticPaths() {
  const paths = []

  return {
    paths,
    fallback: 'blocking',
  }
}
